export const CREATE_LEAD_QUERY = `
    mutation createLead(
        $concerned_area: String!
        $concerned_area_category: String!
        $country: String!
        $country_code: Int!
        $device: String
        $device_type: String
        $email: String!
        $mobile: Float!
        $name: String!
        $page_url: String
        $requirement: String!
        $source: String
        $user_agent: String
        $user_ip_address: String
        $user_type: UserType
        $placement : String
        $utm : [UtmInput!],
        $city: String,
        $state: String
    )
    {
        createLead(createLeadInput: {
            concerned_area: $concerned_area,
            concerned_area_category: $concerned_area_category,
            country: $country,
            country_code: $country_code,
            device: $device,
            device_type: $device_type,
            email: $email,
            mobile: $mobile,
            name: $name,
            city: $city,
            state: $state,
            page_url: $page_url,
            requirement: $requirement,
            source: $source
            user_agent: $user_agent,
            user_ip_address: $user_ip_address,
            user_type: $user_type,
            placement : $placement,
            utm : $utm,
        }){
            _id
        }
    }
`;
export const CREATE_LEAD_POP_UP_QUERY = `
    mutation createLead(
        $concerned_area: String
        $concerned_area_category: String
        $country: String!
        $country_code: Int!
        $device: String
        $device_type: String
        $email: String!
        $mobile: Float!
        $name: String!
        $page_url: String
        $requirement: String!
        $source: String
        $user_agent: String
        $user_ip_address: String
        $user_type: UserType
        $placement : String
        $utm : [UtmInput!],
        $city: String,
        $state: String
    )
    {
        createLead(createLeadInput: {
            concerned_area: $concerned_area,
            concerned_area_category: $concerned_area_category,
            country: $country,
            country_code: $country_code,
            device: $device,
            device_type: $device_type,
            email: $email,
            mobile: $mobile,
            name: $name,
            city: $city,
            state: $state,
            page_url: $page_url,
            requirement: $requirement,
            source: $source
            user_agent: $user_agent,
            user_ip_address: $user_ip_address,
            user_type: $user_type,
            placement : $placement,
            utm : $utm,
        }){
            _id
        }
    }
`;


